import React from 'react'
import css from '@emotion/css'
import styled from '@emotion/styled'
import JustinsFace from './JustinsFace'
import { getEmSize } from '../../../styles/mixins'
import { widths, colors, breakpoints } from '../../../styles/variables'

const Container = styled.div`
  display: flex;
  margin-left: auto;
  margin-right: auto;
  padding-right: 40px;
  align-items: stretch;
  position: relative;

  height: 550px;
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    padding: 0;
    flex-direction: column;
    height: auto;
  }
`

const JustinsFaceContainer = styled.div`
  width: 60%;
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    width: 100%;
    height: 400px;
    img {
      object-position: 50% 50% !important;
      object-fit: cover !important;
    }
  }
`

const ContentContainer = styled.div`
  width: 70%;
  position: absolute;
  right: 50px;
  bottom: 100px;
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    position: relative;
    width: 100%;
    right: unset;
    padding-left: 15px;
    padding-right: 15px;
    bottom: unset;
  }
`

const Title = styled.h1`
  color: ${colors.darkBlue};
  font-size: 50px;
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    font-size: 30px;
    margin-top: 20px;
  }
`

export default function Hero() {
  return (
    <Container>
      <JustinsFaceContainer>
        <JustinsFace style={{ width: '100%', height: '100%' }} objectPosition="0% 100%" objectFit="contain" />
      </JustinsFaceContainer>
      <ContentContainer>
        <Title>
          Justin Jones for Congress is a <span style={{ color: colors.red }}>grassroots campaign</span> fighting for{' '}
          <span style={{ color: colors.lightBlue }}>working people</span> across{' '}
          <span style={{ color: colors.red }}>Middle Tennessee.</span>
        </Title>
      </ContentContainer>
    </Container>
  )
}
